
import { type CrawlResult, type EnhancedCrawlResult } from '@/types/crawler';

/**
 * Validates a crawl result to ensure it has content we can use
 */
export function validateContent(result: CrawlResult | EnhancedCrawlResult | null): { 
  isValid: boolean; 
  message?: string;
  pageContent?: string;
  domain?: string;
} {
  console.log('🔍 FAQ Expert: Validating crawl result content...');
  
  // Only proceed if we have a selected page with content
  if (!result || !result.pages || result.pages.length === 0) {
    console.error('❌ FAQ Expert: No pages in crawl result');
    return { 
      isValid: false,
      message: "No page content available for FAQ generation"
    };
  }

  // Get the main page content
  const mainPage = result.pages[0];
  const pageContent = mainPage.content || "";
  
  console.log(`📄 FAQ Expert: Page content length: ${pageContent.length} chars`);
  console.log(`🔗 FAQ Expert: Page URL: ${mainPage.url}`);
  
  if (!pageContent || pageContent.length < 200) {
    console.error(`❌ FAQ Expert: Content too short (${pageContent.length} chars)`);
    return {
      isValid: false,
      message: `Page content is too short for meaningful FAQ generation (${pageContent.length} chars). Need at least 200 characters.`
    };
  }

  const domain = new URL(mainPage.url).hostname;
  
  // Log content characteristics for debugging
  const wordCount = pageContent.split(/\s+/).length;
  const contentPreview = pageContent.substring(0, 200).replace(/\s+/g, ' ').trim();
  
  console.log(`✅ FAQ Expert: Content validation passed - ${wordCount} words`);
  console.log(`📝 FAQ Expert: Content preview: "${contentPreview}..."`);
  
  return {
    isValid: true,
    pageContent,
    domain
  };
}
